const DEFAULTS = {
  NEED_HELP_MAIL: 'support@purview.net',
  NEED_HELP_PHONE: '+1 800-501-1537',
  VIEWER_GUIDE_URL: 'https://info.purview.net/hubfs/SECURE%20SHARE%20Purview%20Viewer%20with%203D%20Tools.pdf',
}

export const getSupportMail = () => window.NEED_HELP_MAIL || DEFAULTS.NEED_HELP_MAIL
export const getSupportPhone = () => window.NEED_HELP_PHONE || DEFAULTS.NEED_HELP_PHONE
export const getViewerGuideUrl = () => {
  if (window.VIEWER_GUIDE_URL === false) return null
  return window.VIEWER_GUIDE_URL || DEFAULTS.VIEWER_GUIDE_URL
}
